module.exports = __webpack_public_path__ + "static/media/Bolzano.5695e666.jpg";